// plugins/axios.js

import axios from 'axios';
import store from '@/store';
import {eltips} from './eltips.js'
import {getStorage,removeStorage,setErrLog} from './util.js'

const instance = axios.create({
	
});

instance.interceptors.request.use(
	config => {
		// 在请求发送之前做一些处理
		const token = getStorage('token');
		if(token) config.headers.Authorization = 'Bearer' + token;
		return config;
	},
	error => {
		// 处理请求错误
		setErrLog('axios请求发起错误',error)
		return Promise.reject(error);
	}
);

instance.interceptors.response.use(
	response => {
		if (response.status == 200) {
			if (response.data.code == 401) {
				store.commit('changeLoginDialog', true);
				removeStorage('token')
				removeStorage('userinfo')
			} else {
				return response.data
			}
		} else {
			eltips('服务器错误','error')
		}
	},
	error => {
		// 处理响应错误
		setErrLog('axios返回错误',error)
		return Promise.reject(error);
	}
);

export default {
	install(Vue) {
		Vue.prototype.$axios = instance;
	}
};